$(document).ready(function() {
    let pageContent = $('#logistics_introduction_wrapper #page_content');
    let pageContentList = $('#logistics_introduction_wrapper #page_content_list');
    let links = pageContentList.find('li a');

    if (!pageContent.length || !links.length) {
        return;
    }

    let activeClasses = pageContentList.attr('data-active-class');
    let inactiveClasses = pageContentList.attr('data-inactive-class');

    function setActiveLink(activeLink) {
        links.each(function() {
            let link = $(this);
            link.closest('li').removeClass('active');
            link.removeClass(activeClasses).addClass(inactiveClasses);
        });

        activeLink.closest('li').addClass('active');
        activeLink.removeClass(inactiveClasses).addClass(activeClasses);
    }

    function setActiveLinkFromScroll() {
        let scrollTop = pageContent.scrollTop() + 5;
        let activeLink = links.first();

        links.each(function() {
            let link = $(this);
            let target = $(link.attr('href'));

            if (target.length && target.position().top + pageContent.scrollTop() <= scrollTop) {
                activeLink = link;
            }
        });

        setActiveLink(activeLink);
    }

    links.on('click', function(event) {
        event.preventDefault();

        let link = $(this);
        let target = $(link.attr('href'));
        if (!target.length) {
            return;
        }

        setActiveLink(link);
        pageContent.scrollTop(target.position().top + pageContent.scrollTop());
    });

    pageContent.on('scroll', setActiveLinkFromScroll);
    setActiveLinkFromScroll();
});
